/** @format */
import {HotspotKey} from '../../../types';

interface ReturnResult {
  column1: HotspotKey[];
  column2: HotspotKey[];
}

const spreadSmallBlocks = (keys: HotspotKey[]): ReturnResult => {
  const sortedKeys = keys.toSorted((a, b) => (a === 'mediaplan' ? -1 : b === 'mediaplan' ? 1 : 0));

  switch (sortedKeys.length) {
    case 1:
      return {
        column1: sortedKeys,
        column2: [],
      };
    case 2:
      return {
        column1: sortedKeys,
        column2: [],
      };
    case 3:
      return {
        column1: sortedKeys.slice(0, 1),
        column2: sortedKeys.slice(1),
      };
    case 4:
      return {
        column1: sortedKeys.slice(0, 2),
        column2: sortedKeys.slice(2),
      };
    default:
      return {
        column1: [],
        column2: [],
      };
  }
};

export {spreadSmallBlocks};
